exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "action .ui-button {\n  overflow: hidden;\n  font-size: 1em;\n  height: 2em;\n  padding: 0 .5em;\n  border: 0 none; }\n  action .ui-button .ui-button-text {\n    line-height: normal; }\n\naction .ui-button-text-icon-left .ui-button-text, action .ui-button-text-icon-right .ui-button-text {\n  padding-left: .5em !important;\n  padding-right: .5em !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/app/component-module/action/action.component.scss
// module id = ../../../../../src/app/component-module/action/action.component.scss
// module chunks = main